/*
  Chargeur des correctifs du tunnel de verres, Les Lunettes de Pauline.

  Appele par sections/lens-tunnel.liquid, uniquement sur les fiches ou le tunnel
  s'affiche. Il ne contient rien d'autre que le chargement de ses compagnons,
  afin d'eviter d'avoir a modifier la section :

    lt-correctifs-tunnel.js  correctifs 1 a 5 du tunnel lui-meme
    lt-garde-fous.js         bornes de saisie et avertissement hors limites
    lt-mutuelle.js           case a cocher sur les conditions de prise en charge
    lt-devis-patient.js      bloc patient : securite sociale, ordonnance, delivrance
    lt-devis-lot1.js         mise en forme reglementaire du devis normalise
    lt-devis-appairage.js    prestation d'appairage, rubrique 1.3
    lt-devis-solaire.js      verres teintes : avertissement et remboursement nul

  L'ordre compte pour les deux derniers : ils enveloppent tous deux la fonction
  de composition du devis, et le solaire doit passer en dernier pour ramener a
  zero ce que l'appairage aurait pu ajouter.

  Reglages du devis que l'on peut changer ICI, sans republier les 46 ko de
  lt-devis-lot1.js. Decommenter et modifier, ils sont poses avant le chargement
  des compagnons donc ils prennent le dessus sur les valeurs par defaut :

    window.LT_DEVIS_REGLAGES = { tva: 0.2, livraison: 5.99 };
    window.LT_DEVIS_REFERENCE = { marque: 'Owlet Originals',
                                  matiere: 'Plastique injecte' };

  ATTENTION. Les compagnons sont appeles en reprenant l'adresse de CE fichier,
  donc son jeton de version. Modifier un compagnon sans toucher a lt-correctifs.js
  laisse le CDN servir l'ancienne version du compagnon, sans aucun message
  d'erreur, et ajouter un parametre a l'adresse n'y change rien. Il faut modifier
  une ligne ici, la revision ci-dessous, pour forcer le rafraichissement.

  Revision 20, 7 octobre 2026 : verres teintes. Le devis ne laisse plus croire
  a un remboursement sur une paire de solaires a la vue, et la case a cocher
  du tunnel le dit avant l'ajout au panier.
*/
(function () {
  'use strict';

  var moi = document.currentScript;
  if (!moi || !moi.src) { return; }

  [
    'lt-correctifs-tunnel',
    'lt-garde-fous',
    'lt-mutuelle',
    'lt-devis-patient',
    'lt-devis-lot1',
    'lt-devis-appairage',
    'lt-devis-solaire'
  ].forEach(function (nom) {
    var url = moi.src.replace('lt-correctifs', nom);
    if (url === moi.src) { return; }
    var s = document.createElement('script');
    s.src = url;
    s.defer = true;
    document.head.appendChild(s);
  });
})();